import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '@sb-tools/typescript/authentication/authentication.service';

@Injectable()
export class TiktokRedirectGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const urlSearchParams = new URLSearchParams(route.queryParams);
        const community = this.authenticationService.community;
        const tikTokToken = urlSearchParams.get('code');

        if (community) {
            if (tikTokToken) {
                this.router.navigate([`/${community}/community/installation/tiktok`], {
                    queryParams: { code: tikTokToken },
                });
            } else {
                this.router.navigate([`/${community}/community/installation/tiktok`]);
            }
        }

        return true;
    }
}
